import axios, { AxiosError } from 'axios';
import { environment } from '@environments/environment';
import { OpaSubscription } from '@models/Opa';

export const getRetailSubscription = async (): Promise<OpaSubscription> => {
  const { data } = await axios
    .get<OpaSubscription>(`${environment.baseUrl}/opa/v2/retail_subscription`)
    .catch((err: AxiosError | Error) => {
      throw new Error(`An error has occurred: ${err}`);
    });
  return data;
};
